<template>
  <v-autocomplete
    v-model="item"
    :label="label"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    clearable
    hide-no-data
    :hide-details="hideDetails"
    item-text="nazev"
    item-id="id"
    return-object
    :rules="rules"
  >
    <template
      slot="selection"
      slot-scope="{ item, selected }"
    >
      <span v-text="item.nazev"></span>
    </template>
    <template
      slot="item"
      slot-scope="{ item, tile }"
    >
      <v-list-tile-content>
        <v-list-tile-title>{{ item.nazev }}</v-list-tile-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  data: function () {
    return {
      loading: false,
      items: [],
      search: "",
      counter: 0,
      timeout: null,
      item: null
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: Number,
    all: Boolean,
    disabled: Boolean,
    label: String,
    id: Number,
  },
  watch: {
    id () {
      this.load();
    },
    item (v) {
      this.$emit("changed", v);
      this.$emit("input", v != null ? v.id : null);
    }
  },
  mounted: function() {
    this.load()
  },
  methods: {
    load: function(v) {
      this.loading = true
      window.api.get("sporici-produkty/" + this.$props.id + "/cilove-produkty").then(function($r) {
        this.items = $r;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
